import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Validators, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { SdkService }  from "../../services/sdk.service";
import { SharedService }  from "../../services/shared.service";
import { BrandProfileService } from '../../services/brand-profile.service';
import { EventEmitterService } from '../../services/event-emitter.service';
import { IDisbursementSession } from '../../interfaces/disbursement-session';
import { IBrandProfile } from 'src/app/interfaces/brand-profile';
import { IStateProvince } from '../../interfaces/state-province';
//import { IPageHeader } from '../../interfaces/page-header';
import { IPageContent } from '../../interfaces/page-content';
import { faUniversity, faCalendar, faAddressCard, faHome, faCity } from '@fortawesome/free-solid-svg-icons';
import { faCoffee, faBuilding, faEnvelopeOpen, faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';

@Component({
  selector: 'app-funding-account-card',
  templateUrl: './funding-account-card.component.html',
  styleUrls: ['./funding-account-card.component.css']
})
export class FundingAccountCardComponent implements OnInit, OnChanges {

  envRegion!: string;
  disbursementSession!: IDisbursementSession;
  brandProfile!: IBrandProfile;

  //headerData!: IPageHeader;
  cardForm: FormGroup;

  pageContent!: IPageContent;

  billerAccountId: string = '';
  transactionType: string = '';
  // accountTypes = [
  //   {code: 'PersonalChecking', literal: 'Personal Checking' },
  //   {code: 'PersonalSavings', literal: 'Personal Savings' },
  //   {code: 'BusinessChecking', literal: 'Business Checking' },
  //   {code: 'BusinessSavings', literal: 'Business Savings' }
  // ];
  selectedAccountType?: string;

  stateProvinces!: IStateProvince[];

  isDsbMessageShown: boolean = false;
  dsbMessage: string = '';

  faAddressCard = faAddressCard;
  faUniversity = faUniversity;
  faCalendar = faCalendar;
  faHome = faHome;
  faBuilding = faBuilding;
  faEnvelopeOpen = faEnvelopeOpen;
  faCoffee = faCoffee
  faBriefcase = faBriefcase;
  faCity = faCity;

  public mask1 = [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/]
  public mask2 = [/\d/, /\d/, '/', /\d/, /\d/]

  public constructor(
    private router: Router,
    private fb: FormBuilder,
    private sdkService: SdkService,
    private sharedService: SharedService,
    private brandProfileService: BrandProfileService,
    private eventEmitterService: EventEmitterService
    ) {
      // console.log('FundingAccountAchComponent', 'constructor');
      this.cardForm = this.fb.group({
        'account-holder-name': new FormControl('', [Validators.required]),
        'iframe-card-number': new FormControl(''),
        'iframe-expiration-date': new FormControl(''),
        'iframe-security-code': new FormControl(''), 
        'account-region-code': new FormControl('', [Validators.required]),
        'account-postal-code': new FormControl('', [Validators.required]),
        'funding-account-nickname': new FormControl(''),
        'errMessage': new FormControl('')
      });
    }

    ngOnInit(): void {
      console.log('FundingAccountCardComponent', 'ngOnInit');

      // Get the current enviromental region
      this.envRegion = this.sharedService.getEnvRegion();

      // Get the current brand profile
      if (this.sharedService.getBrandProfile()) {
        this.brandProfile = this.sharedService.getBrandProfile();
      } else {

      }

      // Make preparations for the page generic content
      this.pageContent = {
        headerTitle: this.sharedService.getCustomizedTitle('APP_TITLE') || '',
        headerSubtitle: this.sharedService.getCustomizedTitle('CARD') || '',
        headerAvatar: 'card.svg'
      }

      // Get the current disbursement session
      this.disbursementSession = this.sharedService.getDisbursementSession();

      // do we need to remove any account types from the list if they are not configured for the biller?
      if (this.disbursementSession) {
        // this.accountTypes.forEach((item,index)=>{
        //   if (this.disbursementSession.fundingAccountTypes.indexOf(item.code) < 0) this.accountTypes.splice(index,1);
        // });

        // // Load up the SDk script
        // if (this.disbursementSession.billerId) {
        //   this.sdkService.loadJsSdkScript(this.disbursementSession.billerUuid);
        // }  

        // Initiliaize the SDK gateway
        try {
          this.sdkService.initGateway(this.envRegion, this.disbursementSession, 'Card', this.cardForm);
        } catch (e: any){
            console.log(e);
            alert(e);
        } finally {
            console.log('finally');
        }
      }

      // Get a list of state provinces
      this.getStateProvinces();   
      
      // Subscribe to possible exception events
      this.eventEmitterService.invokeCardFundingAccountExceptionEvent.subscribe(message => {
        // console.log('funding-account-ach - onInit - subscription', message);
        this.dsbMessage = message;
        if (message) {
          this.isDsbMessageShown = true;
        } else {
          this.isDsbMessageShown = false;
        }
        // console.log('isDsbMessageShown', this.isDsbMessageShown);
      });   
      
      this.eventEmitterService.invokeCardElementValueChanged.subscribe( () =>{
        this.closeDsbMessage();
      });   
      
    }

    private getStateProvinces() {
      this.brandProfileService.getStatesProvinces()
      .subscribe({
        next: (response) => {
          this.stateProvinces = response;
        },
        error: (e) => {
        },
        complete: () => {
        }
      });
    }    

    changeAccountType(e: any) {
      console.log(e.target.value);
    }

    ngOnChanges(changes: SimpleChanges) {
    }

    // onSubmitCard() {
    //   // ......
    //   this.router.navigate(['/dsb-funding-accounts']);
    // }

    onCancel() {
      this.router.navigate(['/dsb-funding-accounts']);
    }

    closeDsbMessage() {
      this.dsbMessage = '';
      this.isDsbMessageShown = false;
    }


  }
